import React, { useMemo } from "react";
import styled from "styled-components";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";
import ParseHTML from "../../common/ParseHTML";

import { Column } from "../../../utils/models";
import { formatTime } from "../../../utils/utilities";
import { FULL_DATE_FORMAT } from "../../../utils/constants";
import { CDRInformationModel, CDRReviewInformation } from "../../forms/custom-cdr/schema";

import css from "../../../components/themed/pdf/pdf.module.scss";

interface Props {
    information: CDRInformationModel;
    reviewData: CDRReviewInformation;
}

const Signature = styled.div`
    font-family: 'Allison', cursive;
    white-space: nowrap;
    font-size: 1.25rem;
    padding: 0.75rem;
    line-height: 1rem;
`;

const ReviewApproval: React.FC<Props> = ({ information, reviewData }) => {
    const data = useMemo(() => {
        if (!reviewData || !information) {
            return [];
        }

        return [
            {
                label: 'Type of Equipment:',
                value: information.equipmentType,
            },
            {
                label: 'Condition Code:',
                value: information.conditionCode,
            },
            {
                label: 'Category:',
                value: information.category,
            },
            {
                label: 'Ram Assessment:',
                value: information.ramAssessment,
            },
            {
                label: 'Onsite Inspection Engineer Name:',
                value: reviewData.onSiteEngineerName.value,
            },
            {
                label: 'Signature:',
                value: <Signature className={css["signature-font"]}>{reviewData.onSiteEngineerName.value}</Signature>,
            },
            {
                label: 'Signed Date:',
                value: formatTime(reviewData.onSiteReviewDate, FULL_DATE_FORMAT),
            },
            {
                label: 'Report Reviewer Name:',
                value: reviewData.reportReviewerName.value,
            },
            {
                label: 'Report Reviewer Recommendations:',
                value: <ParseHTML text={reviewData.reportReviewerRecommendation} />,
            },
            {
                label: 'Signature:',
                value: <Signature className={css["signature-font"]}>{reviewData.reportReviewerName.value}</Signature>,
            },
            {
                label: 'Signed Date:',
                value: formatTime(reviewData.reportReviewDate, FULL_DATE_FORMAT),
            },
            {
                label: 'MCI Team Leader Name:',
                value: reviewData.mciLeaderName.value,
            },
            {
                label: 'Signature:',
                value: <Signature className={css["signature-font"]}>{reviewData.mciLeaderName.value}</Signature>,
            },
            {
                label: 'Signed Date:',
                value: formatTime(reviewData.mciReviewDate, FULL_DATE_FORMAT),
            },
        ]
    }, [reviewData, information]);

    return ( 
        <CustomSection
            sectionTitle="Review & Approval"
            showMetadata={false}
            titleStyle={{ paddingLeft: '1rem', justifyContent: 'flex-start', backgroundColor: '#2e4e6a', color: '#FFFFFF', textAlign: 'left' }}
        >
            <div className="p-1">
                <PDFTablePage data={data} columns={columns} />
            </div>
        </CustomSection>
    );
};

const columns: Column[] = [
    {
        path: 'label',
        label: 'Label',
        style: () => ({ textAlign: 'left', fontWeight: '700', border: 'none' }),
        headerStyle: { textAlign: 'left', display: 'none' },
    },
    {
        path: 'value',
        label: 'Value',
        style: () => ({ textAlign: 'left', border: 'none' }),
        headerStyle: { textAlign: 'left', display: 'none' },
    },
];

export default ReviewApproval;